import React, { PureComponent } from 'react';
import style from './styles/style.module.css';

// import iconFile from 'appSrc/assets/icons/custom/x.svg';
import iconFileColored from 'appSrc/assets/icons/custom/plus-colored.svg';

export default class PlusIcon extends PureComponent {
    render() {
        var inlineStyles = { ...this.props.style };
        const source = this.props.colored ? iconFileColored : iconFileColored;
        if( this.props.size ) {
            inlineStyles.width = inlineStyles.height = this.props.size + 'px';
        }
        return (
            <div className={ `${ this.props.className } ${ style.icon }` } style={ inlineStyles }>
                <img src={ source } alt={ this.props.label }/>
            </div>
        );
    }
}
PlusIcon.defaultProps = {
    className: '',
    label: 'x icon',
};
